import { useState ,useMemo  } from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Box,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Popover,
  FormGroup,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  MoreHoriz as MoreHoriz,
} from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./card.scss";
import Label from "../Label/Label";
import FilterListIcon from "@mui/icons-material/FilterList";

export default function SampleAccordionList({
  data,
  openData,
  handleClick,
  handleMenuOptionCallBack,
  moreOption,
  handleMenuClick,
  batchData,
  batchID
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [menuItemLabel, setMenuItemLabel] = useState(null);
  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorE2);

  const handleChildMenuClick = (event, label) => {
    event.stopPropagation(); // prevent expanding when clicking dots
    setAnchorE2(event.currentTarget);
    setMenuItemLabel(label);
  };

  const handleChildMenuClose = () => {
    setAnchorE2(null);
    setMenuItemLabel(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuItemLabel(null);
  };

  const handleMenuOption = (option, item) => {
    handleMenuOptionCallBack(option, item);
    handleMenuClose();
    handleChildMenuClose();
  };

  const [anchorFilter, setAnchorFilter] = useState(null);
  const openFilter = Boolean(anchorFilter);
  const handleClickFilter = (event) => {
    setAnchorFilter(event.currentTarget);
  };

  const handleCloseFilter = () => {
    setAnchorFilter(null);
  };

  // const handleCheckboxChange = (option) => {
  //   setSelectedFilters((prev) =>
  //     prev.includes(option)
  //       ? prev.filter((item) => item !== option)
  //       : [...prev, option]
  //   );
  // };

   const groupedData = useMemo(() => {
    const groups = {};
    data?.data?.forEach((item) => {
      const phase = item.phase || "";
      if (!groups[phase]) groups[phase] = [];
      groups[phase].push(item);
    });
    return groups;
  }, [data]);

  return (
    <Paper elevation={1} className="sample-container" sx={{ height: "100%" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* <Label padding="12px 12px 1px 12px" text="Uploaded Data"></Label> */}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Label
          padding="12px 14px 12px 12px"
          text={"Batch ID : " + batchID}
        ></Label>
      </Box>
     {openData?.rows?.length > 0 && <List component="nav" disablePadding>
        {Object.keys(groupedData).map((phase, idx) => (
          <Box key={idx} className="phase-section">
            {/* 🧾 Phase Header */}
            {phase && (
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                backgroundColor: "#e6ebf2",
                px: 2,
                py: 0,
                border: "1px solid #ccc",
                mb: 1,
                mt: 1
              }}
            >
            Phase-  {phase}
            </Typography>)}

            {/* 📋 Items under each phase */}
            {groupedData[phase].map((item, index) => (
              <ListItemButton
                key={index}
                className={`menu-list-item ${
                  (openData?.tab === item.tab && item.phase === openData.phase)  ? "active" : ""
                }`}
                onClick={() => handleMenuClick(item)}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <ListItemText
                  primary={item.tab}
                  className="list-item-text"
                  primaryTypographyProps={{
                    sx: {
                      color: (openData?.tab === item.tab && item.phase === openData.phase) ? "#fff" : "black",
                      cursor: "pointer",
                      width: "100%",
                    },
                  }}
                />
              </ListItemButton>
            ))}
          </Box>
        ))}
      </List>
}
      {/* Options Menu */}
    </Paper>
  );
}
